<!-- Vista compartida para el detalle moderno de zonas infrarrojas. -->
<section class="zone-monitor" *ngIf="location">
  <div class="zone-state loading" *ngIf="loading">
    <span class="zone-loader" aria-hidden="true"></span>
    <div><strong>Cargando datos de la zona</strong><small>Consultando alarmas y último dato disponible...</small></div>
  </div>

  <div class="zone-state error" *ngIf="!loading && loadError">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <div><strong>No fue posible cargar la zona</strong><small>Intenta nuevamente en unos momentos.</small></div>
    <button type="button" (click)="fetchData()">Reintentar</button>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <header class="zone-summary">
      <span class="zone-avatar"><i class="fa fa-crosshairs" aria-hidden="true"></i></span>
      <div class="zone-identity">
        <small>Zona infrarroja monitoreada</small>
        <h2>{{ location.name || 'Zona sin nombre' }}</h2>
        <p><i class="fa fa-microchip" aria-hidden="true"></i>{{ deviceDescription }}</p>
      </div>
      <span class="alarm-status" [class.has-alarms]="alarmList.length">
        <i class="fa" [ngClass]="alarmList.length ? 'fa-exclamation-circle' : 'fa-check-circle'"></i>
        {{ alarmList.length ? (alarmList.length + ' alarmas hoy') : 'Sin alarmas hoy' }}
      </span>
    </header>

    <div class="zone-metrics">
      <article><span>Tipo</span><strong>{{ deviceTypeName }}</strong><small>Clasificación del activo</small></article>
      <article><span>Dispositivo</span><strong>{{ deviceDescription }}</strong><small>Equipo asociado</small></article>
      <article><span>Altitud</span><strong>{{ altitudeLabel }}</strong><small>Altura configurada</small></article>
      <article><span>Último dato</span><strong>{{ lastSensorData?.create_date ? (lastSensorData.create_date | date:'dd/MM/yyyy HH:mm') : 'Sin datos' }}</strong><small>Última comunicación</small></article>
    </div>

    <section class="zone-panel alarm-history">
      <div class="zone-panel-heading">
        <div><h3>Alarmas últimas 24 horas</h3><p>Distribución de detecciones registradas durante el día.</p></div>
        <div class="zone-chart-meta">
          <span class="chart-period"><i class="fa fa-clock-o" aria-hidden="true"></i>{{ chartPeriodLabel }}</span>
          <span>{{ alarmList.length }} evento{{ alarmList.length === 1 ? '' : 's' }}</span>
        </div>
      </div>

      <div class="zone-chart">
        <div class="zone-chart-canvas">
          <canvas baseChart
            [datasets]="alarmChartData"
            [labels]="[]"
            [options]="alarmChartOptions"
            [colors]="alarmChartColors"
            [legend]="false"
            [chartType]="alarmChartType">
          </canvas>
        </div>
      </div>

      <div class="zone-empty-note" *ngIf="!alarmList.length">
        <i class="fa fa-check-circle"></i>
        Sin alarmas activas: el gráfico representa el período sin eventos registrados.
      </div>
    </section>

    <footer class="zone-actions">
      <button type="button" (click)="goBack()"><i class="fa fa-times" aria-hidden="true"></i>Cerrar</button>
    </footer>
  </ng-container>
</section>
